module.exports = __webpack_public_path__ + "static/media/landing-3homes-middle.34d16aeb.svg";